import type { ComponentType } from 'react';
import { Button } from 'react-bootstrap';
import { useLangContext } from '../../providers/LangProvider/LangProviderContext.js';
import { BinIcon as BinIconBase } from '../../components/Icon/Icon.jsx';
import {
    PromoHighlightItemStyled,
    PromoHighlightsStyled,
    PromoKitPanelStyled,
    PromoPageStyled,
    PromoSectionStyled,
} from './styled/PromoStyled';

const MARKETING_KIT_URL = 'https://drive.google.com/drive/folders/1sxNBNsyl8LbGtzfATV9Cc8GMOJrOB3Rr';

const HIGHLIGHT_KEYS = ['creatives', 'brand', 'ready'] as const;

const BinIcon = BinIconBase as ComponentType<{ name: string; size?: string }>;

function Promo() {
    const { getLangPath } = useLangContext();

    return (
        <PromoPageStyled>
            <div className="page-header">
                <span className="section-eyebrow">{getLangPath('promo.eyebrow')}</span>
                <h1 className="page-title">{getLangPath('promo.title')}</h1>
                <p className="page-desc">{getLangPath('promo.desc')}</p>
            </div>

            <PromoSectionStyled>
                <div className="section-header">
                    <div className="section-heading">
                        <span className="section-eyebrow">{getLangPath('promo.kit_step')}</span>
                        <h2 className="section-title">{getLangPath('promo.kit_title')}</h2>
                        <p className="section-desc">{getLangPath('promo.kit_desc')}</p>
                    </div>
                </div>

                <PromoKitPanelStyled>
                    <p className="kit-label">{getLangPath('promo.kit_label')}</p>
                    <h3 className="kit-title">{getLangPath('promo.kit_name')}</h3>
                    <p className="kit-desc">{getLangPath('promo.kit_panel_desc')}</p>
                    <div className="kit-actions">
                        <Button variant="primary" href={MARKETING_KIT_URL} target="_blank" rel="noreferrer">
                            {getLangPath('promo.open_kit')}
                            <BinIcon name="IcShareArrow" size="16px" />
                        </Button>
                    </div>
                </PromoKitPanelStyled>
            </PromoSectionStyled>

            <PromoSectionStyled>
                <div className="section-header">
                    <div className="section-heading">
                        <span className="section-eyebrow">{getLangPath('promo.includes_step')}</span>
                        <h2 className="section-title">{getLangPath('promo.includes_title')}</h2>
                        <p className="section-desc">{getLangPath('promo.includes_desc')}</p>
                    </div>
                </div>

                <PromoHighlightsStyled>
                    {HIGHLIGHT_KEYS.map((key) => (
                        <PromoHighlightItemStyled key={key}>
                            <p className="highlight-title">{getLangPath(`promo.highlights.${key}.title`)}</p>
                            <p className="highlight-desc">{getLangPath(`promo.highlights.${key}.desc`)}</p>
                        </PromoHighlightItemStyled>
                    ))}
                </PromoHighlightsStyled>
            </PromoSectionStyled>
        </PromoPageStyled>
    );
}

export default Promo;
